module.exports = __webpack_public_path__ + "static/group-51-d21e2d53c52cdbe9db9c3bc15e34bf86.svg";